import { Dropdown, Menu } from 'antd';
import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Table } from 'semantic-ui-react';
import iframe from '../../dashboard-routes/Iframe/iframeData';

import {
  TableEmptyMessage,
  TableFooterPagination,
  TableHeader,
} from '../../shared/table';
import SalesCallReportStore from './SalesCallReportStore';

const columns = [
  { title: '' },
  { title: 'ID' },
  { title: 'Case Manager' },
  { title: 'Client' },
  { title: 'Content' },
  { title: 'Call By', sortKey: 'CallBy' },
  { title: 'Call Date', sortKey: `CallDate` },
  { title: 'Client Service Officer' },
];

@observer
class SalesCallReportTable extends React.Component {
  renderTableActions = record => (
    <Dropdown
      trigger={['click']}
      overlay={<Menu>{/* <Menu.Item>Delete</Menu.Item> */}</Menu>}
    >
      <Icon name="ellipsis vertical" />
    </Dropdown>
  );
  openCaseDetails = record => e => {
    e.preventDefault();
    const id = record.CMId;
    localStorage.setItem('CmName', `${record.CMFullName}`);
    iframe.forceOpenTab('ViewCM', `?id=${id}&view=ViewCM`, {
      id,
      view: 'ViewCM',
    });
  };
  renderTableBody = () => {
    return SalesCallReportStore.data.itemList.map((record, idx) => (
      <Table.Row key={idx}>
        <Table.Cell className="Cell-actions">
          {this.renderTableActions(record)}
        </Table.Cell>
        <Table.Cell
          className="Cell-link"
          onClick={this.openCaseDetails(record)}
          selectable
        >
          <Link to="#" onClick={this.openCaseDetails(record)}>
            {record.CMId}
          </Link>
        </Table.Cell>
        <Table.Cell className="Cell-link">
          <div>
            <span style={{ fontWeight: 'bold' }}>{record.CMFullName}</span>
          </div>
          <div>
            <span>{record.CMNumber}</span>
          </div>
          <div>
            <span>{record.CMPosition}</span>
          </div>
          <div>
            <span>{record.CMType}</span>
          </div>
        </Table.Cell>
        <Table.Cell>{record.CMClientName}</Table.Cell>
        <Table.Cell style={{ minWidth: '250px' }}>{record.Notes}</Table.Cell>
        <Table.Cell>{record.CallBy}</Table.Cell>
        <Table.Cell>{record.CallDate}</Table.Cell>
        <Table.Cell>{record.ClientServiceOfficer}</Table.Cell>
      </Table.Row>
    ));
  };

  handlePageClick = page => {
    SalesCallReportStore.refetch({ curPage: page - 1 });
  };

  render() {
    const { loading, data } = SalesCallReportStore;
    const colSpan = columns.length;

    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader
          columns={columns}
          sortColumn={SalesCallReportStore.sortColumn}
          sortDirection={SalesCallReportStore.sortDirection}
          onSort={SalesCallReportStore.handleSort}
        />
        <Table.Body>
          {data.itemList.length ? (
            this.renderTableBody()
          ) : (
            <TableEmptyMessage colSpan={colSpan} />
          )}
        </Table.Body>
        <TableFooterPagination
          colSpan={colSpan}
          totalItems={SalesCallReportStore.totalItem}
          currentPage={SalesCallReportStore.curPage + 1}
          totalPage={SalesCallReportStore.totalPage}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}

export default SalesCallReportTable;
